import { SelectQuery } from './select-query';



export class SelectDataSource  {
    // Url do recurso.
    url: string = '';
    // Consulta que será enviada para o servidor.
    query: SelectQuery<any> = new SelectQuery<any>();

    constructor(init?: Partial<SelectDataSource>) {
        Object.assign(this, init);
    }
}

